/** 통합검색 input + 검색 + 류 바로가기.
 *
 * scope dropdown 은 폐기 — 검색 결과 페이지 좌측 사이드바 "검색범위" 와
 * 중복이라 사용자 혼란. 검색은 항상 통합검색(all) 으로 시작 → 결과 페이지
 * 사이드바에서 좁힘.
 */
import React, { useState } from "react";
import { Search } from "lucide-react";
import { CHAPTERS_97 } from "./chaptersData";
import "./theme.css";

export default function SearchBar({
  initialQuery = "",
  onSearch,
  onChapterJump,
}) {
  const [q, setQ] = useState(initialQuery);

  const submit = () => {
    if (q.trim()) onSearch?.({ q: q.trim(), scope: "all" });
  };

  return (
    <div
      className="audit-root"
      style={{
        display: "flex",
        gap: 6,
        alignItems: "center",
        padding: 12,
        borderBottom: "1px solid var(--audit-border)",
        background: "var(--audit-bg)",
      }}
    >
      <input
        type="text"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && submit()}
        placeholder="keyword 또는 line item (예: PERFUME ROSE 30ML)"
        style={{
          flex: 1,
          padding: "8px 12px",
          fontSize: 13,
          border: "1px solid var(--audit-border-strong)",
          background: "var(--audit-bg)",
          color: "var(--audit-text)",
          borderRadius: 6,
        }}
      />

      <button
        className="audit-btn audit-btn-primary"
        onClick={submit}
        disabled={!q.trim()}
        style={{ display: "flex", alignItems: "center", gap: 4 }}
      >
        <Search size={14} /> 검색
      </button>

      <select
        value=""
        onChange={(e) => {
          if (e.target.value) {
            onChapterJump?.(e.target.value);
            e.target.value = "";
          }
        }}
        style={{
          padding: "8px 10px",
          fontSize: 12,
          border: "1px solid var(--audit-border-strong)",
          background: "var(--audit-bg)",
          color: "var(--audit-text-muted)",
          borderRadius: 6,
          minWidth: 130,
        }}
      >
        <option value="">류 바로가기 ▾</option>
        {CHAPTERS_97.map(({ ch, name }) => (
          <option key={ch} value={ch}>
            {ch} {name}
          </option>
        ))}
      </select>
    </div>
  );
}
